import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { updateAiModel, getAimodel } from "../../actions/UserActions";

class Aiversions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: props.title || "Ai Versions",
      modeltype: "",
      showLoader: false,
      validation: false,
    };
  }

  componentDidMount() {
    this.getAimodel();
  }

  onChangeseletfeild = (e) => {
    if (e != "") {
      this.setState({
        showLoader: true,
        validation: false,
      });
      let data = {
        gptModel: e,
      };
      this.props
        .updateAiModel(data)
        .then((res) => {
          if (res.status === 200) {
            this.setState({
              showLoader: false,
            });
            this.getAimodel();
          }
        })
        .catch((err) => {});
    } else {
      this.setState({
        validation: true,
      });
    }
  };

  getAimodel = () => {
    this.setState({
      showLoader: true,
    });

    this.props
      .getAimodel()
      .then((res) => {
        if (res.status == 200) {
          this.setState({
            modeltype: res.data.gptModel,
          });
          this.setState({
            showLoader: false,
          });
        }
      })
      .catch((err) => {});
  };

  render() {
    return (
      <div>
        <Row className="mx-0 page-head-row page-head-row-big align-items-center">
          <Col className="col-auto">
            <h4 className="title-med mt-0 pt-1">{this.state.title}</h4>
          </Col>
          <Col className="col-auto">
            <Form.Group controlId="" className="mb-0 mr-2" />
          </Col>
        </Row>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <section style={{ backgroundColor: "#eee" }}>
            <div class="container py-5">
              <div class="row">
                <div class="col-md-6 col-lg-6 col-xl-6">
                  <ul class="list-unstyled">
                    <li> AI versions</li>
                    <li class="bg-white mb-3">
                      <div class="form-outline">
                        <div className="c-select status-select mt-2 mb-2">
                          <select
                            className="form-control form-control-sm form-control-head"
                            style={{ width: "100%" }}
                            onChange={(e) => {
                              this.onChangeseletfeild(e.target.value);
                            }}
                            value={this.state.modeltype}
                          >
                            <option value="">Select Version Type</option>
                            <option value="text-davinci-003">gpt-3.5</option>
                            <option value="gpt-4">gpt-4</option>
                          </select>
                        </div>
                        {this.state.validation ? (
                          <p style={{ color: "red" }}>
                            Model type cannot be empty
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  { updateAiModel, getAimodel }
)(Aiversions);
